<template>
  <div>
    <!-- 新增/编辑的对话框 -->
    <el-dialog class="edit-dialog" :title="title" :visible.sync="dialogVisible" width="50%" :modal-append-to-body="true"
      append-to-body close-on-click-modal @closed="handleClose">
      <!-- 新增/编辑的表单 -->
      <el-form ref="form" :model="form" :rules="rules" label-width="160px" size="small"
        :validate-on-rule-change="false">
        <el-form-item label="策略名称" prop="name">
          <el-input maxlength="99" size="small" v-model="form.name" placeholder="请输入卡片名称" clearable></el-input>
        </el-form-item>
        <!-- 展示页面：必填、下拉单选 -->
        <el-form-item label="展示页面" prop="displayPage">
          <el-select v-model="form.displayPage" placeholder="请选择展示页面" size="small" clearable>
            <el-option v-for="item in displayPage" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title">
              <div class="title-blue">
                策略命中配置&nbsp;<i class="header-icon el-icon-info"></i>
              </div>
            </template>
            <el-form-item label="客户端  " prop="platforms" class="platforms">
              <el-popover placement="top-start" title=" " width="400" trigger="hover" content="
                ">
                <i slot="reference" class="el-icon-question platforms-icon" />
                <div>
                  1. 默认勾选，值为空时，则覆盖所有版本<br />
                  2. 按输入版本号范围覆盖版本<br />
                  &nbsp;2.1. 只输入最小版本号，最大版本为空时，则代表大于最小版本号的版本都生效<br />
                  &nbsp;2.2. 最小和最大版本号同时输入，则只生效该范围内<br />
                  3. 当取消勾选时，则该端不生效页面策略
                </div>
              </el-popover>

              <el-checkbox-group v-model="platforms" @change="platformsChange">
                <el-checkbox v-for="item in platform" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
              </el-checkbox-group>
          </el-form-item>
          <!-- 客户端版本 -->
          <el-form-item v-for="(platform, index) in form.platforms" :key="index" :label="`${platform.platform}客户端版本`"
            :prop="`platforms.${index}.minClientVersion`">
            <div style="display: flex;">
              <el-input-number style="margin-right: 10px;" size="small" v-model="platform.minClientVersion" :min="0"
                clearable></el-input-number>
              <el-input-number size="small" v-model="platform.maxClientVersion" :min="0" clearable></el-input-number>
            </div>
          </el-form-item>
          <!-- 渠道选择 必填、radio单选 -->
          <el-form-item label="渠道选择" prop="channelType">
            <el-radio-group v-model="form.channelType">
              <el-radio :label="1">全部渠道</el-radio>
              <el-radio :label="2">渠道白名单</el-radio>
              <el-radio :label="3">渠道黑名单</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 指定渠道 -->
          <el-form-item v-if="form.channelType === 2 || form.channelType === 3" label="指定渠道" prop="appIds">
            <el-input type="textarea" @focus="channelInputClick(item)" v-model="form.appIds" style="width: 80%;">
            </el-input>
            <channel-popups :isAppendToBody="true" :modelIsAppendToBody="false" :app-id="form.channel.ids"
              :visible.sync="channelVisible" @comfirm="channelConfirm($event, item)" :multiple="true"></channel-popups>
          </el-form-item>
          <!-- 指定UID -->
          <el-form-item label="指定UID" prop="uid">
            <el-input v-model="form.uid" placeholder="多个用英文逗号分隔" type="textarea" style="width: 80%;"></el-input>
          </el-form-item>
          </el-collapse-item>
          <!-- 投屏功能配置 -->
          <el-collapse-item name="2" v-if="form.displayPage == 1">
            <template slot="title">
              <div class="title-blue">投屏功能配置&nbsp;<i class="header-icon el-icon-info"></i></div>
            </template>
            <el-form-item label="功能配置" prop="screenConfig">
              <el-select v-model="form.screenConfig" placeholder="请选择功能配置" @change="screenConfigChange">
                <el-option v-for="item in screenConfigSelectList" :key="item.value" :label="`(${item.value}) ${item.label}`" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="行数据">
              <div class="config-row-data" v-if="form.screenConfig">
                <div class="config-row-data-item" v-for="(item, index) in currentScreenConfig" :key="index">
                  <div class="config-row-data-item-label" style="color: #858585;">
                    {{ `行${index + 1}：${item}` }}
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template slot="title">
              <div class="title-blue">
                内容卡片配置&nbsp;<i class="header-icon el-icon-info"></i>
              </div>
            </template>
            <!-- 卡片选择 -->
            <el-form-item label="卡片选择" prop="cardIds">
              <el-button size="small" @click="selectAppCards" style="margin-bottom: 10px">选择</el-button>
              <avue-crud v-if="form.cardIds.length" style="width: 100%" :option="option" :data="form.cardIds" ref="crud"
                @sortable-change="sortChange">
                <!-- 自定义搜索框 -->
                <template slot="mySearch"> </template>
                <!-- 自定义表格列 -->
                <template #coverImg="{ row }">
                  <el-image v-if="row.coverImg" style="width: 100px; height: 100px" :src="row.coverImg"
                    fit="scale-down"></el-image>
                  <span v-else>暂无图片</span>
                </template>
                <template #menu="{ row }">
                  <el-button v-if="!row.top" size="small" type="text" @click="goSticky(row)">置顶</el-button>
                  <el-button v-if="row.top" size="small" type="text" @click="cancelSticky(row)">取消置顶</el-button>
                  <el-button size="small" type="text" @click="delCards(row)">移除</el-button>
                </template>
              </avue-crud>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
        <!-- 备注 -->
        <el-form-item label="备注" prop="remark" style="margin-top: 30px;">
          <el-input v-model="form.remark" placeholder="请输入备注" type="textarea" style="width: 80%;" maxlength="999"></el-input>
        </el-form-item>
        <!-- 状态 -->
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">生效</el-radio>
            <el-radio :label="0">失效</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <!-- 保存和取消按钮 -->
      <div class="btn-container" style="text-align: right; margin-top: 20px">
        <el-button size="small" type="primary" @click="save">保存</el-button>
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
    </el-dialog>
    <!-- 卡片置顶时间选择 -->
    <TimeSelect ref="timeSelect" @save="cardTopTimeSave"></TimeSelect>
    <MultipleCards ref="multipleCards" @save="getContentList"></MultipleCards>
  </div>
</template>

<script>
import {
  addPageStrategy,
  editPageStrategy,
  getShowPages,
  getScreenConfig,
} from "@/api/apps/pageStrategy";
import ChannelPopups from "@/components/channel-popups";
import Message from "@/components/Message";
import { formatAddData } from "../utils/index";
import MultipleCards from "./multipleCards.vue";
import TimeSelect from "./timeSelect.vue";
import { cloneDeep } from "lodash";
export default {
  name: "WebSaaSEdit",

  components: {
    ChannelPopups,
    MultipleCards,
    TimeSelect,
  },
  computed: {
    title() {
      return this.optionType === "add" ? "策略新增" : "策略编辑";
    },
    /** 表单验证规则 */
    rules() {
      const rules = {
        name: [
          { required: true, message: "请输入策略名称", trigger: "blur" },
          { max: 99, message: "策略名称不能超过99个字符", trigger: "blur" },
        ],
        displayPage: [
          { required: true, message: "请选择展示页面", trigger: "blur" },
        ],
        channelType: [
          { required: true, message: "请选择渠道类型", trigger: "blur" },
        ],
        appIds: [
          { required: true, message: "请选择指定渠道", trigger: "blur" },
        ],
        screenConfig: [
          { required: true, message: "请选择投屏功能配置", trigger: "change" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        platforms:
        {
          require: true,
          validator: (rule, value, callback) => {
            /** 选择一个即可 */
            if (this.platforms.length === 0) {
              callback(new Error('客户端至少选择一个'));
            } else {
              callback();
            }

          }, trigger: 'change'
        },
      }
      this.form.platforms.forEach((item, index) => {
        rules.platforms[index] = {
          minClientVersion: [
            {
              required: true,
              validator: (rule, value, callback) => {
                const minVersion = Number(item.minClientVersion) || 0;
                const maxVersion = Number(item.maxClientVersion) || 0;

                // 如果两个字段都为空或者都是0，验证通过
                if ((!minVersion && minVersion !== 0) && (!maxVersion && maxVersion !== 0)) {
                  callback();
                  return;
                }

                // 如果有任一字段为0或空字符串，验证通过
                if ((minVersion === 0 || minVersion === '') || (maxVersion === 0 || maxVersion === '')) {
                  callback();
                  return;
                }

                // 验证格式: 允许数字和空字符串
                const versionPattern = /^\d*$/;
                if (!versionPattern.test(minVersion) || !versionPattern.test(maxVersion)) {
                  callback(new Error('请输入正确格式的版本号'));
                  return;
                }

                // 如果同时填写了最小版本和最大版本，检查大小关系
                if (minVersion > maxVersion) {
                  callback(new Error('最小版本号必须小于等于最大版本号'));
                  return;
                }

                // 所有验证通过
                callback();
              },
              trigger: 'blur'
            }
          ]
        };


      })
      return rules;
    },

  },
  data() {
    return {
      /** 折叠面板 */
      activeNames: ['1', '2', '3'],
      /** 客户端数组 */
      platforms: ['Android', 'IOS', '小程序', '鸿蒙'],
      /** 客户端枚举 */
      platform: [{
        label: 'Android',
        value: 'Android',
      }, {
        label: 'IOS',
        value: 'IOS',
      }, {
        label: '小程序',
        value: '小程序',
      },
      {
        label: '鸿蒙',
        value: '鸿蒙',
      }
    ],
      /** 业务字典的展示页面 */
      displayPage: [],
      /** 渠道选择对话框 */
      channelVisible: false,
      /** 对话框是否可见 */
      dialogVisible: false,
      /** 操作类型 */
      optionType: "add",
      /** 投屏功能配置列表 */
      screenConfigList: [],
      /** 投屏功能配置下拉列表 */
      screenConfigSelectList: [],
      /** 当前选中的投屏功能配置 */
      currentScreenConfig: [],
      /** 表单数据 */
      form: {
        /** 客户端 */
        platforms: [
          {
            platform: 'Android',
            minClientVersion: '',
            maxClientVersion: '',
          },
          {
            platform: 'IOS',
            minClientVersion: '',
            maxClientVersion: '',
          },
          {
            platform: '小程序',
            minClientVersion: '',
            maxClientVersion: '',
          },
          {
            platform: '鸿蒙',
            minClientVersion: '',
            maxClientVersion: '',
          }
        ],
        /** 渠道 */
        channel: {
          ids: "",
          names: "",
        },
        /** 策略名称 */
        name: "",
        /** 展示页面 */
        displayPage: "",
        /** 渠道选择 */
        channelType: "",
        /** 指定渠道 */
        appIds: "",
        /** 投屏功能配置 */
        screenConfig: "",
        /** 卡片选择 */
        cardIds: [],
        /** 指定UID */
        uid: "",
        /** 备注 */
        remark: "",
        /** 状态 */
        status: "",
      },
      option: {
        lazy: true,
        tip: false,
        simplePage: true,
        searchShow: false,
        // searchMenuSpan: 6,
        tree: true,
        border: true,
        /** 表格索引 */
        index: true,
        /** 索引说明 */
        indexLabel: "序号",
        /** 表格搜索显隐按钮 */
        searchShowBtn: false,
        /** 是否启用功能按钮 */
        searchIcon: false,
        searchIndex: 0,
        /** 表格查看按钮 */
        viewBtn: false,
        /** 表格新增按钮 */
        addBtn: false,
        /** 表格删除按钮 */
        delBtn: false,
        /** 表格修改按钮 */
        editBtn: false,
        /** 表格搜索按钮 */
        searchBtn: false,
        /** 表格清空按钮 */
        emptyBtn: false,
        /** 表格列操作按钮 */
        columnBtn: false,
        /** 表格刷新数据按钮 */
        refreshBtn: false,
        /** 开启拖拽功能 */
        sortable: true,
        // dragHandler: true,
        rowSort: true,
        columnSort: true,
        menu: true,
        menuWidth: 120,
        // menuFixed: true,
        column: [
          {
            label: "卡片ID",
            prop: "id",
            width: 60,
          },
          {
            label: "卡片名称",
            prop: "name",
            overHidden: true,
          },
          {
            label: "卡片类型",
            prop: "type",
            //  1：焦点卡片；2：专题卡片；3：导航卡片 4：榜单卡片 5：追剧投屏卡片；6：内容卡片；7：内容横滑卡片；8：直播卡片 9:导航横滑卡片）
            dicData: [
              {
                label: "焦点卡片",
                value: 1,
              },
              {
                label: "专题卡片",
                value: 2,
              },
              {
                label: "导航卡片",
                value: 3,
              },
              {
                label: "榜单卡片",
                value: 4,
              },
              {
                label: "追剧投屏卡片",
                value: 5,
              },
              {
                label: "内容卡片",
                value: 6,
              },
              {
                label: "内容横滑卡片",
                value: 7,
              },
              {
                label: "直播卡片",
                value: 8,
              },
              {
                label: "导航横滑卡片",
                value: 9,
              },
              {
                label: '焦点组卡片',
                value: 10,
              }
            ],
          },
          {
            label: "图片",
            prop: "coverImg",
            slot: true,
            width: 140,
          },
          {
            label: "卡片标题",
            prop: "title",
          },

          {
            label: "状态",
            prop: "status",
            dicData: [
              {
                label: "待生效",
                value: 2,
              },
              {
                label: "生效",
                value: 1,
              },
              {
                label: "失效",
                value: 0,
              },
            ],
          },
          {
            label: "置顶时间",
            prop: "top",
            formatter: (row) => {
              if (row.topStartTime) {
                return `${row.topStartTime} 至 ${row.topEndTime}`;
              } else {
                return "-";
              }
            },
          },
          {
            label: "",
            prop: "my",
            hide: true,
            showColumn: false,
            search: true,
            display: false,
            menuClassName: "myClass",
            searchslot: true,
          },
        ],
      },
    };
  },
  created() {
    this.getShowPages();
    this.getScreenConfig();
  },
  methods: {
    /** 客户端选择变更 */
    platformsChange(val) {
      const existingPlatforms = new Map(
        this.form.platforms.map(platform => [platform.platform, platform])
      );

      this.form.platforms = val.map(item => {
        const platform = existingPlatforms.get(item) || { platform: item };
        return {
          platform: item,
          minClientVersion: platform.minClientVersion || '',
          maxClientVersion: platform.maxClientVersion || '',
        };
      });
    },
    /** 新增的方法 */
    async add(form) {
      const params = formatAddData(form);
      const { data } = await addPageStrategy(params);
      console.log("新增的响应", data);
      if (data.code === 200) {
        Message.success("新增成功");
        this.$emit("reload");
        this.hide();
      }
    },
    /** 编辑的方法 */
    async edit(form) {
      const params = formatAddData(form);
      const { data } = await editPageStrategy(params);
      console.log("编辑的响应", data);
      if (data.code === 200) {
        Message.success("编辑成功");
        this.$emit("reload");
        this.hide();
      }
    },
    //^ ^--------------表单的事件-------------^ ^
    /** 取消 */
    cancel() {
      this.hide();
    },
    /** 保存 */
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.displayPage !== 1) {
            this.form.screenConfig = ''
          }

          if (this.optionType === "add") {
            this.add(this.form);
          } else {
            this.edit(this.form);
          }
        }
      });
    },
    /** 取消置顶的事件 */
    cancelSticky(row) {
      console.log("取消置顶的事件", row);
      /** 根据CardId 来查找卡片 */
      const index = this.form.cardIds.findIndex((item) => item.id === row.id);
      console.log("index", index);
      if (index !== -1) {
        this.$set(this.form.cardIds[index], "top", false);
        this.$set(this.form.cardIds[index], "topStartTime", "");
        this.$set(this.form.cardIds[index], "topEndTime", "");
      }
      console.log("form", this.form);
    },
    /** 置顶的事件 */
    goSticky(row) {
      console.log("置顶的事件", row);
      this.$refs.timeSelect.show(row.id);
    },
    /** 接收卡片置顶时间的事件 */
    cardTopTimeSave(row) {
      console.log("接收卡片置顶时间的事件", row);
      /** 根据CardId 来查找卡片 并赋值置顶开始时间和结束时间 */
      const index = this.form.cardIds.findIndex(
        (item) => item.id === row.cardId
      );
      console.log("index", index);
      if (index !== -1) {
        this.$set(this.form.cardIds[index], "top", true);
        this.$set(this.form.cardIds[index], "topStartTime", row.topTime[0]);
        this.$set(this.form.cardIds[index], "topEndTime", row.topTime[1]);
      }
      console.log("form", this.form);
    },
    /** 删除卡片列表 */
    delCards(row) {
      console.log("删除卡片列表", row);
      const { id } = row;
      const index = this.form.cardIds.findIndex((item) => item.id === id);
      this.form.cardIds.splice(index, 1);
    },
    /** 排序的事件 */
    sortChange(oldindex, newindex, row, list) {
      console.log("row", row);
      console.log("list", list);
      /** 只留下id */
      const items = list.map((item) => {
        return item.id;
      });
      console.log("排序之后的idList", items);
    },
    /** 选择卡片列表 */
    selectAppCards() {
      console.log("选择内容列表", this.form.cardIds);
      this.$refs.multipleCards.show([...this.form.cardIds]);
    },
    /** 接收选择卡片列表 */
    getContentList(list) {
      console.log("getContentList", list);
      this.form.cardIds = list;
    },
    /** 点击渠道选择框 */
    channelInputClick(item) {
      console.log("点击渠道选择框", item);
      this.channelVisible = true;
    },

    /** 确认渠道选择 */
    channelConfirm($event, item) {
      console.log("渠道选择的数据", $event, item);
      const { appId, nameStr } = $event;
      this.form.channel.ids = appId;
      this.form.channel.names = nameStr;
      const idAry = appId.split(",");
      const nameAry = nameStr.split(",");
      this.form.appIds = idAry.map((item, index) => {
        return `[${item}] ${nameAry[index]}`;
      });
    },
    //^ ^--------------对话框相关-------------^ ^
    async show(row, optionType) {
      this.dialogVisible = true;
      if (row) {
        // 使用深拷贝避免数据污染
        this.form = cloneDeep(Object.assign({}, this.form, row))
        this.form.screenConfig = row.screenCastConfigId;
        this.form.uid = row.uidStr || "";

        this.platforms = row.platforms.map(item => {
          return item.platform
        })

        if (this.form.screenConfig) {
          this.currentScreenConfig = this.screenConfigList.find(item => item.id === this.form.screenConfig).rowData;
        }
      }
      this.optionType = optionType || "add";
    },
    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.hide();
      /** 重置表单数据 */
      this.form = {
        /** 客户端 */
        platforms: [
          {
            platform: 'Android',
            minClientVersion: '',
            maxClientVersion: '',
          },
          {
            platform: 'IOS',
            minClientVersion: '',
            maxClientVersion: '',
          },
          {
            platform: '小程序',
            minClientVersion: '',
            maxClientVersion: '',
          },
          {
            platform: '鸿蒙',
            minClientVersion: '',
            maxClientVersion: '',
          }
        ],
        /** 策略名称 */
        name: "",
        /** 展示页面 */
        displayPage: "",
        /** 渠道选择 */
        channelType: "",
        /** 指定渠道 */
        appIds: "",
        /** 卡片选择 */
        cardIds: [],
        channel: {
          ids: "",
          names: "",
        },
        /** 投屏功能配置 */
        screenConfig: "",
        /** uid */
        uid: "",
        /** 备注 */
        remark: "",
        /** 状态 */
        status: "",
      };
      this.platforms = ['IOS', 'Android', '小程序', '鸿蒙']
      /** 清除表单验证规则 */
      this.$refs.form.clearValidate();
    },
    //^ ^--------------初始化数据-------------^ ^
    /** 获取业务字典里的展示页面 */
    async getShowPages() {
      const { data } = await getShowPages();
      console.log("获取业务字典里的展示页面的响应", data);
      if (data.code === 200) {
        this.displayPage = data.data.map((item) => {
          return {
            label: item.dictValue,
            value: Number(item.dictKey),
          };
        });
      }
    },
    /** 获取投屏功能配置 */
    async getScreenConfig() {
      try {
        const { data } = await getScreenConfig();
        if (data.code === 200) {
          this.screenConfigList = data.data;
          
          this.screenConfigSelectList = this.screenConfigList.map(item => {
            return {
              label: item.name,
              value: item.id,
            }
          })        
        }
      } catch (error) {
        console.error("获取投屏功能配置失败:", error);
        Message.error("获取投屏功能配置失败");
      }
    },
    /** 投屏功能配置变更 */
    screenConfigChange(val) {
      console.log("投屏功能配置变更", val);
      const config = this.screenConfigList.find(item => item.id === val);
      this.currentScreenConfig = config ? config.rowData : [];
    }
  },
};
</script>

<style lang="scss" scoped>
//^ ^--------------avue-crud的样式-------------^ ^
::v-deep .avue-crud__menu {
  display: none;
}

::v-deep .avue-crud .el-card {
  padding: 0 !important;
  overflow: auto !important;
}

.avue-crud {
  position: relative;
  left: -150px;
  width: 120% !important;
}

.avue-crud .avue-input-number,
.avue-crud .el-cascader,
.avue-crud .el-date-editor.el-input,
.avue-crud .el-date-editor.el-input__inner,
.avue-crud .el-select,
.avue-form .avue-input-number,
.avue-form .el-cascader,
.avue-form .el-date-editor.el-input,
.avue-form .el-date-editor.el-input__inner,
.avue-form .el-select {
  width: 70% !important;
}

::v-deep .avue-form__menu--center {
  display: none !important;
}

::v-deep .avue-form__group .el-col-md-6 {
  width: 100%;
}

::v-deep .avue-form__group .el-form-item__content {
  margin-left: 0px !important;
}

::v-deep .avue-crud .avue-crud__search .avue-form .avue-form__group .avue-form__row .el-form-item label {
  float: none;
  display: inline-block;
}

::v-deep .avue-crud__pagination {
  display: none !important;
}

.el-input-number /deep/ .el-input__inner {
  text-align: center;
  /* 将数字内容右对齐 */
}

.is-error /deep/ .el-input-number__decrease,
.is-error /deep/ .el-input-number__increase,
.is-success /deep/ .el-input-number__decrease,
.is-success /deep/ .el-input-number__increase {
  right: 1px !important;
}

/deep/ .platforms {

  position: relative;

  .el-form-item__label {
    padding-right: 40px;
  }

  .platforms-icon {
    position: absolute;
    top: 9px;
    left: -30px;
    color: #409eff;
  }
}

.title-blue {
  position: relative;
  margin-left: 5px;
  /** 伪元素 */
  &:before {
    position: absolute;
    content: "";
    display: inline-block;
    width: 3px;
    height: 14px;
    background-color: #409eff;
    top: 17px;
    left: -5px;
  }
}

.el-collapse {
  border: none;
  /deep/ .el-collapse-item__wrap {
    border: none;
    background-color: #f7f7f7;
    padding-top: 10px;
  }
}
</style>

<style lang="scss">
.edit-dialog {
  .el-dialog {
    margin-top: 3vh !important;
  }
}
</style>
